import { render, staticRenderFns } from "./ProfileLogo.vue?vue&type=template&id=8b4e4afa&"
import script from "./ProfileLogo.vue?vue&type=script&lang=js&"
export * from "./ProfileLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports